/** Canonical public guest funnel (the simple self-assessment page). */
export const SELF_ASSESSMENT_PUBLIC_PATH = '/self-assessment';

/** Retired URL; server, Hosting, and client 301 to {@link SELF_ASSESSMENT_PUBLIC_PATH}. */
export const SELF_ASSESSMENT_LEGACY_SIMPLE_PATH = '/self-assessment-simple';

/** Retired classic capture URL; 301 to {@link SELF_ASSESSMENT_PUBLIC_PATH}. */
export const SELF_ASSESSMENT_LEGACY_CAPTURE_PATH = '/self-assessment/capture';

/**
 * Pathnames that 301 to {@link SELF_ASSESSMENT_PUBLIC_PATH}.
 * Express has `strict routing` off by default, so a route of `/self-assessment/`
 * also matches `/self-assessment`. Callers must skip the redirect when this
 * returns null so the canonical document is not redirected onto itself.
 */
export function canonicalSelfAssessmentRedirectPath(pathname: string): string | null {
  if (pathname === SELF_ASSESSMENT_PUBLIC_PATH) {
    return null;
  }
  const withoutTrailingSlash =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  if (
    withoutTrailingSlash === SELF_ASSESSMENT_PUBLIC_PATH ||
    withoutTrailingSlash === SELF_ASSESSMENT_LEGACY_SIMPLE_PATH ||
    withoutTrailingSlash === SELF_ASSESSMENT_LEGACY_CAPTURE_PATH
  ) {
    return SELF_ASSESSMENT_PUBLIC_PATH;
  }
  return null;
}
